import { createContext } from 'react';

import NewsStore from './NewsStore';

const NewsStoreContext = createContext<{ store: NewsStore | null }>({
  store: null
});

const NewsStoreProvider = NewsStoreContext.Provider;

export { NewsStoreContext, NewsStoreProvider };
